var _style, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIntersection45(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 546.03 61",
    style: {
      enableBackground: "new 0 0 546.03 61"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;opacity:0.53;fill:#1A8EB4;enable-background:new    ;}\r\n\t.st1{opacity:0.53;fill:#1A8EB4;enable-background:new    ;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Intersection_2",
    className: "st0",
    d: "M0,61V0h96.63C74.86,31.45,41.81,53.3,4.34,61H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Intersection_3",
    className: "st0",
    d: "M432.4,61c9.79-22.6,23.55-43.26,40.64-61h72.56v61H432.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Intersection_4",
    className: "st1",
    d: "M0,61V0h172.57c17.09,17.74,30.85,38.4,40.64,61H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Intersection_5",
    className: "st1",
    d: "M412.83,60.5c29.84-37.92,75.44-60.04,123.7-60c3.19,0,6.36,0.09,9.5,0.28V60.5H412.83z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntersection45);
export default __webpack_public_path__ + "static/media/Intersection4-5.2f541ca5f6a6c20462ff1edc833ae752.svg";
export { ForwardRef as ReactComponent };